import { render, staticRenderFns } from "./AttributeManageDialog.vue?vue&type=template&id=6d1a98a6"
import script from "./AttributeManageDialog.vue?vue&type=script&lang=js"
export * from "./AttributeManageDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports